import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import AssessmentSyncSetup from "./routes/AssessmentSyncSetup";

export default store => ({
  path: "assessment-sync",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-assessmentSync" */ "./components"),
      import(
        /* webpackChunkName: "admin-schoolSetup-integrations" */ "Integrations/modules/IntegrationsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const integrationsModuleKey = importedModule1.NAME;
      const integrationsModuleReducer = importedModule1.default;

      injectReducer(store, {
        key: integrationsModuleKey,
        reducer: integrationsModuleReducer,
      });

      return component;
    })
  ),
  childRoutes: [AssessmentSyncSetup(store)],
});
